import React, { useEffect, useState } from "react";
import Chat from "../components/common/Chat";
import Toolbar from "../navigation/Toobar";
import Header from "../layout/Header";

function PasswordChange({ showAlert }){
  const [data, setData] = useState({
		old_password: "",
		new_password: "",
		new_password_confirmation: "",
	});

	const [passwordShown, setPasswordShown] = useState({
		old_password: false,
		new_password: false,
		new_password_confirmation: false,
	});

	const [error, setError] = useState("");
  const [dialog, setDialog] = useState({ open: false, type: '', message: '' });
	const [token, setToken] = useState(localStorage.getItem("token"));
	useEffect(() => {
		setToken(localStorage.getItem("token"));
	}, []);
	

  const togglePasswordVisibility = (name) => {
		let data = {...passwordShown};
		data[name] = !data[name];
		setPasswordShown(data);
	};

	const updatePassword = () => {
    // Removed complexity validation: accept any password string
		if(!data.old_password) {
			setError("Please enter your current password.");
			return;
		}
		if(!data.new_password_confirmation) {
			setError("Please confirm your new password.");
			return;
		}
		if(data.new_password !== data.new_password_confirmation) {
			setError("Passwords do not match.");
			return;
		}

		setError("");
		fetch(`${process.env.REACT_APP_API_URL}/api/user-pwd`, {
			method: "POST",
			headers: {
				'Authorization': `Bearer ${token}`,
				'Content-Type': 'application/json',
			},
			body: JSON.stringify(data)
		}).then(response => {
			if (!response.ok) {
				return response.json().then(errData => {
					const errMsg = errData?.message || "Failed to change password. Please try again.";
					throw new Error(errMsg);
				});
			}
			return response.json();
		}).then(data => {
      // Success dialog
      setDialog({ open: true, type: 'success', message: 'Password changed successfully. Please login with your new password.' });
      // Optional: auto-redirect after short delay
      setTimeout(() => {
        window.location.href = "/login";
      }, 1500);
		}).catch(error => {
			console.error("Error:", error);
      const msg = error?.message || "An error occurred while changing the password. Please try again.";
      setError(msg);
      setDialog({ open: true, type: 'error', message: msg });
		});
	};
    return(
        <div className="v-application--wrap">
  <div>
    {/**/}
    <div className="row no-gutters">
      <Header/>
    </div>
    <div className="body">
      <div className="profileLayout-padding margin-desktop">
       
       
        <div className="row mobile-full-height no-gutters">
          
          <div className="col col-12">
            <div className="changePassword-wrapper">
              <div className="row hidden-md-and-up" style={{height: '75px'}}>
                <div className="password-mobile-header text-center col col-12">
                  Change password
                </div>
              </div>
              <div className="desktop_card v-card v-sheet theme--dark">
                <div className="v-card__title hidden-sm-and-down"><label className="--v-primary-base text-left text-capitalize">Change password</label></div>
                <div className="profile-detail-card v-card v-sheet theme--dark elevation-0">
                  {dialog.open && (
                    <div className="pc-dialog-overlay" style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 2000 }}>
                      <div className="pc-dialog-card v-card v-sheet theme--dark" style={{ width: '90%', maxWidth: '360px', background: '#16072e', borderRadius: '8px', padding: '16px', textAlign: 'center' }}>
                        <div style={{ marginBottom: '12px', color: dialog.type === 'success' ? '#4CAF50' : '#F44336', fontWeight: 'bold' }}>
                          {dialog.type === 'success' ? 'Success' : 'Failed'}
                        </div>
                        <div style={{ color: '#fff', marginBottom: '16px' }}>{dialog.message}</div>
                        <div className="row no-gutters justify-center" style={{ gap: '8px' }}>
                          <button type="button" className="v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary" onClick={() => setDialog({ open: false, type: '', message: '' })}>
                            <span className="v-btn__content">OK</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                  {error && (
                    <div className="error-message" style={{ color: 'red', fontSize: '16px', marginTop: '10px', textAlign: 'center' }}>
                      {error}
                    </div>
                  )}
                  <form noValidate="novalidate" className="v-form">
                    <div className="row px-8 pt-4 no-gutters align-end">
                      <div className="col-md-5 col-lg-4 col">
                        <div className="mobile">
                          <div className="row no-gutters justify-space-between">
                            <div className="col col-10">
                              <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Current password<span className="red--text ml-1">*</span></label>
                            </div>
                            <div className="col col-2">{/**/}</div>
                            <div className="col col-12">
                              <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                <div className="v-input__control">
                                  <div className="v-input__slot">
                                    <fieldset aria-hidden="true">
                                      <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                    </fieldset>
                                    <div className="v-text-field__slot">
                                     <input
                                      className="input"
                                      name="old_password"
                                      type={ passwordShown?.old_password===true ? 'text' : 'password'}
                                      placeholder="Current password"
                                      value={data.old_password}
                                      onChange={(e) => {
                                        setData({ ...data, old_password: e.target.value });
                                      }}
                                      autoComplete="current-password"
                                      disabled={false}
                                      readOnly={false}
                                      autoFocus
                                      onKeyDown={(e) => { if (e.key === 'Enter') updatePassword(); }}
                                      style={{ width: '100%', minHeight: '40px', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', background: '#fff', color: '#000' }}
                                     />
                                     </div>
                                     <div className="v-input__append-inner" style={{ display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>
                                      <i
                                        aria-hidden="true"
                                        aria-label="toggle visibility"
                                        className="v-icon notranslate material-icons theme--dark"
                                        role="button"
                                        onClick={() => togglePasswordVisibility('old_password')}
                                      style={{ color: '#6C63FF', cursor: 'pointer' }}
                                      >{passwordShown?.old_password ? 'visibility_off' : 'visibility'}</i>
                                      </div>
                                  </div>
                                  <div className="v-text-field__details">
                                    <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                                  </div>
                                </div>
                              </div>
                              {/**/}{/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row px-8 no-gutters align-end">
                      <div className="col-md-5 col-lg-4 col">
                        <div className="mobile">
                          <div className="row no-gutters justify-space-between">
                            <div className="col col-10">
                              <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> New password<span className="red--text ml-1">*</span></label>
                            </div>
                            <div className="col col-2">
                              <i aria-hidden="true" aria-haspopup="true" aria-expanded="false" className="v-icon notranslate material-icons theme--dark primary--text" style={{float: 'right'}}>help</i>
                              <span className="v-tooltip v-tooltip--right">{/**/}</span>
                            </div>
                            <div className="col col-12">
                              <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                <div className="v-input__control">
                                  <div className="v-input__slot">
                                    <fieldset aria-hidden="true">
                                      <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                    </fieldset>
                                    <div className="v-text-field__slot">
                                    <input
                                      className="input"
                                      name="new_password"
                                      type={ passwordShown?.new_password===true ? 'text' : 'password'}
                                      placeholder="New password"
                                      value={data.new_password}
                                      onChange={(e) => {
                                            setData({ ...data, new_password: e.target.value });
                                          }}
                                      autoComplete="new-password"
                                      disabled={false}
                                      readOnly={false}
                                      onKeyDown={(e) => { if (e.key === 'Enter') updatePassword(); }}
                                      style={{ width: '100%', minHeight: '40px', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', background: '#fff', color: '#000' }}
                                    />
                                    </div>
                                    <div className="v-input__append-inner" style={{ display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>
                                      <i
                                        aria-hidden="true"
                                        aria-label="toggle visibility"
                                        className="v-icon notranslate material-icons theme--dark"
                                        role="button"
                                        onClick={() => togglePasswordVisibility('new_password')}
                                      style={{ color: '#6C63FF', cursor: 'pointer' }}
                                      >{passwordShown?.new_password ? 'visibility_off' : 'visibility'}</i>
                                    </div>
                                    </div>
                                  <div className="v-text-field__details">
                                    <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                                  </div>
                                </div>
                              </div>
                              {/**/}{/**/}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row px-8 no-gutters align-end">
                      <div className="mb-4 col-md-5 col-lg-4 col">
                        <div className="mobile">
                          <div className="row no-gutters justify-space-between">
                            <div className="col col-10">
                              <label className="input-field-label ma-0 text-capitalize d-block pb-1" style={{float: 'left'}}> Confirm new password<span className="red--text ml-1">*</span></label>
                            </div>
                            <div className="col col-2">{/**/}</div>
                            <div className="col col-12">
                              <div className="v-input input-field elevation-0 hide-details theme--dark v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                                <div className="v-input__control">
                                  <div className="v-input__slot">
                                    <fieldset aria-hidden="true">
                                      <legend style={{width: '0px'}}><span className="notranslate">​</span></legend>
                                    </fieldset>
                                    <div className="v-text-field__slot">
                                     <input
                                      className="input"
                                      name="new_password_confirmation"
                                      type={ passwordShown?.new_password_confirmation===true ? 'text' : 'password'}
                                      placeholder="Confirm new password"
                                      value={data.new_password_confirmation}
                                      onChange={(e) => {
                                              setData({ ...data, new_password_confirmation: e.target.value });
                                            }}
                                      autoComplete="new-password"
                                      disabled={false}
                                      readOnly={false}
                                      onKeyDown={(e) => { if (e.key === 'Enter') updatePassword(); }}
                                      style={{ width: '100%', minHeight: '40px', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ccc', background: '#fff', color: '#000' }}
                                     />
                                     </div>
                                     <div className="v-input__append-inner" style={{ display: 'flex', alignItems: 'center', paddingLeft: '8px' }}>
                                      <i
                                        aria-hidden="true"
                                        aria-label="toggle visibility"
                                        className="v-icon notranslate material-icons theme--dark"
                                        role="button"
                                        onClick={() => togglePasswordVisibility('new_password_confirmation')}
                                      style={{ color: '#6C63FF', cursor: 'pointer' }}
                                      >{passwordShown?.new_password_confirmation ? 'visibility_off' : 'visibility'}</i>
                                     </div>
                                       </div>
                                   <div className="v-text-field__details">
                                    <div className="v-messages theme--dark"><div className="v-messages__wrapper" /></div>
                                  </div>
                                </div>
                              </div>
                              {/**/}{/**/}
                            </div>
                          </div>
                        </div>
                        <button onClick={updatePassword} data-v-1dea3caa type="button" className="full-width font-weight-bold pa-2 dialog-button submit-btn v-btn v-btn--is-elevated v-btn--has-bg theme--dark v-size--default buttonPrimary theme-button theme--dark subtitle-1">
                          <span className="v-btn__content">Submit </span>
                        </button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/**/}
      </div>
      {/**/}
    </div>
    <Toolbar/>
    <Chat/>
  </div>
</div>

    );
   
}
 export default PasswordChange;